import type OwaWorkloadStore from "./schema/OwaWorkloadStore";
import type OwaWorkload from "./schema/OwaWorkload";
import { createStore } from "owa-satcheljs";

const owaWorkloadStore: OwaWorkloadStore = {
    currentWorkload: 0,
};

const defaultExport: () => OwaWorkloadStore = createStore<OwaWorkloadStore>("owaWorkload", owaWorkloadStore);
export default defaultExport;
